

import React from "react";
import cardImg1 from "../assets/images/services/img1.jpeg";
import cardImg2 from "../assets/images/nima.jpg";
import cardImg3 from "../assets/images/services/img4.jpg";
import cardImg4 from "../assets/images/services/img3.jpeg";

const resources = {

  blog: {
  heading: {
    badge: "Blog",
    title: "Stories from the Mountains",
    subtitle:
      "Insights, expedition guides, and untold tales from the highest mountains on Earth.",
  },
  posts: [
    {
      id: 1,
      title: "From Dream to Summit: Conquering the Highest Peaks",
      category: "Expedition Guide",
      imageUrl: cardImg1,
      content:
        "Follow the journey behind world-record expeditions and learn what it truly takes to reach the top of the world. Training routines, logistics, permits, and survival  all broken down by the BroadBoy Adventures team.",
      component: React.lazy(() => import("../components/blogs/BlogPost1")),
    },
    {
      id: 2,
      title: "Why Nima Rinji Sherpa’s Record Matters for Every Young Mountaineer",
      category: "Achievements",
      imageUrl: cardImg2,
      content:
        "The Nepalese mountaineer  has etched his name in climbing history by becoming the **youngest person ever** to summit all 14 of the world’s 8,000-meter peaks. On October 9, 2024, at just 18 years old, he completed his final ascent by reaching the summit of  (8,027 m). Nima began high-altitude climbing in 2022, and over a span of roughly two years and 14 summits, he overcame extreme altitude, challenging weather, and logistical hurdles  proving that with skill, determination, and respect for the mountains, unprecedented feats are possible, even at a young age.His achievement is more than just a personal record: for aspiring climbers around the world, especially from Himalayan communities, Nima’s journey signals that age or background need not be a barrier. BroadBoy Adventures draws inspiration from that spirit  aiming to celebrate, support, and elevate young climbers who dream big.\n",
      component: React.lazy(() => import("../components/blogs/BlogPost2")),
    },
    {
      id: 3,
      title: "A Beginner’s Guide to Himalayan Expeditions",
      category: "Resources",
      imageUrl: cardImg3,
      content:
        "New to high-altitude adventures? This guide covers preparation, gear, acclimatization, costs, and choosing the right mountain for your skill level.",
      component: React.lazy(() => import("../components/blogs/BlogPost3")),
    },
    {
      id: 4,
      title: "Inside BroadBoy Basecamps: Where Adventure Comes Alive",
      category: "Article",
      imageUrl: cardImg4,
      content:
        "Step inside the heartbeat of our expeditions  from snowy sunrise briefings to high-altitude resilience. A closer look at the culture, teamwork, and stories from camp life.",
      component: React.lazy(() => import("../components/blogs/BlogPost4")),
    },
  ],
}

};

export default resources;
